import { useParams } from "react-router";
import BackNav from "../../../components/toolbars/BackNav";
import { useQuery } from "@tanstack/react-query";
import { handleFetchRequest } from "../../../api/requests";
import Approver from "./components/Approver";
import { useContext, useState } from "react";
import AcceptRequest from "./components/AcceptRequest";
import RejectRequest from "./components/RejectRequest";
import AssignApprover from "../units/components/AssignApprover";
import formatMoney from "../../../utils/formatMoney";
import Executive from "./components/Executive";
import RemarksRequest from "./components/RemarksRequest";
import { AuthContext } from "../../../contexts/AuthContext";
import { handleFetchRelated } from "../../../api/customers";
import formatAccount from "../../../utils/formatAccount";
import formatShort from "../../../utils/formatShort";

export default function Request() {
  const { auth } = useContext(AuthContext);
  const [acceptModal, setAcceptModal] = useState<boolean>(false);
  const [rejectModal, setRejectModal] = useState<boolean>(false);
  const [assignModal, setAssignModal] = useState<boolean>(false);
  const [remarksModal, setRemarksModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const [type, setType] = useState<any>(null);
  const { id } = useParams();

  const email = auth?.email;
  const { data: request } = useQuery({
    queryKey: ["requests", id],
    queryFn: () => handleFetchRequest({ _id: id }),
  });

  const { data: related } = useQuery({
    queryKey: ["related", id],
    queryFn: () =>
      handleFetchRelated({ keyword: request?.record?.customerName }),
  });

  const handleAccept = async ({ approver, type }: any) => {
    setSelected(approver);
    setType(type);
    setAcceptModal(true);
  };

  const handleReject = async ({ approver, type }: any) => {
    setSelected(approver);
    setType(type);
    setRejectModal(true);
  };

  const handleRemarks = async ({ approver, type }: any) => {
    setSelected(approver);
    setType(type);
    setRemarksModal(true);
  };

  return (
    <div className="bg-gray-100">
      <BackNav />
      <div className="bg-white m-1">
        <div className="p-4">
          <div className="grid grid-cols-12 gap-x-2">
            <div className="col-span-12 sm:col-span-3">
              <div className="font-bold">
                {formatAccount(request?.record?.customerAccount)}:{" "}
                {request?.record?.customerName}
              </div>
              <div className="">
                [ Customer of : {request?.record?.business} ]
              </div>
              <div className="">
                Mobile Number : {request?.record?.customerMobile}
              </div>
              <div className="">
                Email Address : {request?.record?.customerEmail}
              </div>
              <div className="">
                Period Unused : {request?.record?.customerPeriod}
              </div>
              <div className="">
                Current Credit Limit :{" "}
                {formatMoney(request?.record?.creditLimit)}
              </div>
            </div>
            <div className="col-span-12 sm:col-span-4 ">
              <div className="flex items-center justify-between border">
                <div className="border-r p-2 w-48">Company / Business Unit</div>
                <div className="mx-2 text-right">
                  {request?.record?.business}
                </div>
              </div>
              <div className="flex items-center justify-between border">
                <div className="border-r p-2 w-48">Previous TurnOver</div>
                <div className="mx-2 text-right">
                  {formatMoney(request?.record?.preTurnover)}
                </div>
              </div>
              <div className="flex items-center justify-between border">
                <div className="border-r p-2 w-48">YTD TurnOver</div>
                <div className="mx-2">
                  {formatMoney(request?.record?.ytdTurnover)}
                </div>
              </div>
              <div className="flex items-center justify-between border">
                <div className="border-r p-2 w-48">Requested Credit Limit</div>
                <div className="mx-2">
                  {formatMoney(request?.record?.requestedLimit)}
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-5">
              <div>
                {related?.map((item: any, index: number) => (
                  <button
                    className={`flex items-center bg-gray-100 p-2 mb-2 border w-full`}
                    key={index}
                  >
                    <div className="flex flex-col flex-1">
                      <div className="flex font-bold">
                        <div className="w-14 text-left">
                          {formatAccount(item?.account)} :
                        </div>
                        {item?.name}
                      </div>
                      <div className="text-gray-500 text-xxs flex justify-between">
                        <div className="">
                          {item?.business?.name || (
                            <span className="text-red-500">Not Assigned</span>
                          )}{" "}
                        </div>
                        <div className="">
                          Current Credit: {formatShort(item?.currCredit)}
                        </div>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="p-4">
          <div className="border-b-4 w-full pb-2 mb-4 flex justify-between">
            <div className="">List of Approvers:- </div>
          </div>
          <div className="">
            <div className="">
              <div className="py-2 font-bold  mt-4 px-4">
                <div className="border-b pb-1 flex justify-between">
                  <div className="">Credit Controllers</div>
                </div>
              </div>
              <div className="grid grid-cols-12">
                {request?.record?.approvals?.financialControllers?.map(
                  (approver: any, index: number) => (
                    <Approver
                      approver={approver}
                      index={index + 1}
                      last={false}
                      email={email}
                      key={index}
                      auth={auth}
                      type={"Financial Controller"}
                      handleAccept={handleAccept}
                      handleReject={handleReject}
                    />
                  )
                )}
              </div>
            </div>

            <div className="mt-8">
              <div className="py-2 font-bold mt-4 px-4">
                <div className="border-b pb-1">Executives</div>
              </div>
              <div className="grid grid-cols-12">
                {request?.record?.approvals?.executives?.map(
                  (approver: any, index: number) => (
                    <Executive
                      approver={approver}
                      index={index + 1}
                      last={true}
                      key={index}
                      email={email}
                      auth={auth}
                      type={"Executive"}
                      handleRemarks={handleRemarks}
                    />
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AcceptRequest
        isVisible={acceptModal}
        setVisible={setAcceptModal}
        selected={selected}
        request={request?.record}
        type={type}
        id={id}
      />

      <AssignApprover
        isVisible={assignModal}
        setVisible={setAssignModal}
        selected={selected}
      />

      <RejectRequest
        isVisible={rejectModal}
        setVisible={setRejectModal}
        selected={selected}
        request={request?.record}
        type={type}
        id={id}
      />

      <RemarksRequest
        isVisible={remarksModal}
        setVisible={setRemarksModal}
        selected={selected}
        request={request?.record}
        type={type}
        id={id}
      />
    </div>
  );
}
